import { createApp, ref } from 'vue'
import './style.css'
import App from './App.vue'
import router from './router' 
import AgoraRTC from "agora-rtc-sdk-ng"
// import ElementPlus from 'element-plus'
// import 'element-plus/dist/index.css'


const app = createApp(App)
app.use(router)
app.use(AgoraRTC)
// app.use(ElementPlus)
app.mount('#app')